import React, { useState, useRef, useContext } from 'react';
import { useClickAway } from 'react-use';

import RequestButton from '../../ui_kit/utilities/request_button';
import { failToast } from '../../ui_kit/utilities/fail_toast';
import { createUserDeactivates } from '../../../api/user_deactivates';
import { logOut } from '../../../api/users';
import Context from '../../../utils/context';

import styles from './v2.module.css';

const DEACTIVATE_REASONS = [
  { reason: 'I found what I was looking for' },
  { reason: 'I am no longer interested in participating' },
  { reason: 'I have concerns about my privacy' },
  { reason: 'I had a negative experience' },
  { reason: 'Other' },
];

export default function DeactivateModalV2({ setClickModal }) {
  const modalRef = useRef(null);
  const context = useContext(Context);
  const currentUser = context.auth.getCurrentUser();
  const [checkedItems, setCheckedItems] = useState([]);
  const [description, setDescription] = useState('');

  const toggleReason = (reason) => {
    if (checkedItems.includes(reason)) {
      setCheckedItems(checkedItems.filter((item) => item !== reason));
    } else {
      setCheckedItems([...checkedItems, reason]);
    }
  };

  useClickAway(modalRef, () => {
    setClickModal(false);
  });

  const submitUserDeactivate = (afterAction) => {
    const reasons = [...checkedItems];
    createUserDeactivates(reasons, description, currentUser, (data) => {
      if (data['success'] == true) {
        logOut(() => {
          window.location = '/member/login';
          window.localStorage.setItem('showDeactivationToast', 'true');
        });
      } else {
        failToast(
          'Something went wrong, please reach out to support@patientpartner.com for assistance with your request.'
        );
      }

      afterAction();
      setCheckedItems([]);
      setDescription('');
      setClickModal(false);
    });
  };

  const isDisabled = description === '' && checkedItems.length === 0;

  return (
    <div className={styles.modal_backdrop}>
      <div ref={modalRef} className={styles.modal}>
        <div className={styles.modal_header}>
          <h2 className={styles.modal_title}>Deactivate account</h2>
          <button type='button' onClick={() => setClickModal(false)} className={styles.modal_close} aria-label='Close'>
            <img src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/platform/cross.svg' alt='' />
          </button>
        </div>
        <div className={styles.modal_content}>
          <p className={styles.intro}>
            Help us understand what&apos;s going on. Your feedback shapes what we fix next.
          </p>
          <div className={styles.fieldset}>
            {DEACTIVATE_REASONS.map((r) => (
              <label key={r.reason} className={styles.reason_label}>
                <input
                  type='checkbox'
                  className={styles.reason_checkbox}
                  checked={checkedItems.includes(r.reason)}
                  onChange={() => toggleReason(r.reason)}
                />
                <span className={styles.reason_text}>{r.reason}</span>
              </label>
            ))}
          </div>
          <div className={styles.description_container}>
            <p className={styles.description_label}>Description (optional)</p>
            <textarea
              className={styles.description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder='Please provide further context...'
              value={description}
            ></textarea>
          </div>
        </div>
        <div className={styles.modal_footer}>
          <button type='button' onClick={() => setClickModal(false)} className={styles.cancel}>
            Cancel
          </button>
          <RequestButton
            disabled={isDisabled ? 'disabled' : ''}
            classnames={`${styles.deactivate} ${isDisabled ? styles.deactivate_disabled : ''}`}
            request={submitUserDeactivate}
            cta='Deactivate'
          />
        </div>
      </div>
    </div>
  );
}
